export class HeaderNav {
	constructor(root) {
		this.header = root.querySelector('.hp-header-preview');
	}

	init() {
		if (!this.header) return;

		this.nav = this.header.querySelector('.hp-nav');

		this.setupMobileToggle();
		this.setupNavDropdowns();
		this.setupLocationDropdown();
		this.setupGlobalListeners();
	}

	setupMobileToggle() {
		this.toggle = this.header.querySelector('.hp-header__toggle');
		const closeButton = this.header.querySelector('.hp-nav__close');
		if (!this.toggle || !this.nav) return;

		this.toggle.addEventListener('click', () => {
			if (this.nav.classList.contains('is-open')) {
				this.closeDrawer();
			} else {
				this.openDrawer();
			}
		});

		if (closeButton) {
			closeButton.addEventListener('click', () => this.closeDrawer());
		}
	}

	openDrawer() {
		this.nav.classList.add('is-open');
		// .hp-nav itself must stay position:fixed relative to the viewport (it's the
		// drawer), so the header bar fades via opacity instead of sliding with the page —
		// a transform here would make the fixed drawer inherit it as a containing block too.
		this.header.classList.add('is-drawer-open');
		if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');

		// Push the whole page out of the way instead of overlaying the drawer on top of it.
		const width = this.nav.offsetWidth;
		document.body.style.transition = 'transform 0.3s ease';
		document.body.style.transform = `translateX(-${width}px)`;

		// Lock the page's own scroll so scrolling only ever affects the open drawer.
		document.body.style.overflow = 'hidden';
	}

	closeDrawer() {
		this.nav.classList.remove('is-open');
		this.header.classList.remove('is-drawer-open');
		if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
		document.body.style.transform = '';
		document.body.style.overflow = '';
		this.closeAllDropdowns();
	}

	setupNavDropdowns() {
		this.header.querySelectorAll('.hp-nav__item--has-children').forEach((item) => {
			const link = item.querySelector('.hp-nav__link');
			if (!link) return;

			link.addEventListener('click', () => {
				const isOpen = item.dataset.open === 'true';
				this.closeAllDropdowns(item);
				item.dataset.open = String(!isOpen);
				link.setAttribute('aria-expanded', String(!isOpen));
			});
		});
	}

	setupLocationDropdown() {
		// There can be more than one — the same location picker appears both in the
		// desktop topbar and again as its own entry inside the mobile drawer.
		this.header.querySelectorAll('.hp-location').forEach((location) => {
			const toggle = location.querySelector('.hp-header__location');
			if (!toggle) return;

			toggle.addEventListener('click', () => {
				const isOpen = location.dataset.open === 'true';
				this.closeAllDropdowns(location);
				location.dataset.open = String(!isOpen);
				toggle.setAttribute('aria-expanded', String(!isOpen));
			});
		});
	}

	setupGlobalListeners() {
		document.addEventListener('click', (event) => {
			// composedPath (rather than header.contains) is required here because the header
			// can live inside a Shadow DOM, where click targets get retargeted to the shadow host.
			const path = event.composedPath ? event.composedPath() : [event.target];
			if (!path.includes(this.header)) {
				this.closeAllDropdowns();
				if (this.nav && this.nav.classList.contains('is-open')) {
					this.closeDrawer();
				}
			}
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				this.closeAllDropdowns();
				if (this.nav && this.nav.classList.contains('is-open')) {
					this.closeDrawer();
				}
			}
		});

		// If the viewport crosses from mobile to desktop width while the drawer is still
		// open (e.g. rotating a device, or widening a resizable window), the drawer's own
		// CSS stops applying at the breakpoint, but body's transform (pushing the page off
		// to the left) doesn't know that on its own — left uncleared, the page is stuck
		// shifted off-screen with blank space showing. Must match _header.scss's 900px
		// breakpoint exactly.
		const desktopQuery = window.matchMedia('(min-width: 901px)');
		const handleBreakpointChange = (event) => {
			if (event.matches && this.nav && this.nav.classList.contains('is-open')) {
				this.closeDrawer();
			}
		};
		if (desktopQuery.addEventListener) {
			desktopQuery.addEventListener('change', handleBreakpointChange);
		} else {
			// Safari < 14 fallback.
			desktopQuery.addListener(handleBreakpointChange);
		}
	}

	closeAllDropdowns(except) {
		this.header.querySelectorAll('.hp-nav__item--has-children, .hp-location').forEach((item) => {
			if (item !== except) {
				item.dataset.open = 'false';
				const trigger = item.querySelector('.hp-nav__link, .hp-header__location');
				if (trigger) trigger.setAttribute('aria-expanded', 'false');
			}
		});
	}
}
